/**
 * Constants for the list of sort order preferences
 */
export enum SORT_ORDER_PREFERENCE_ENUM {
    AVAILABLE_FIRST = 'available-first',
    SORT_BY_ORDER = 'sort-by-order'
}
/**
 * PALS Payload Room Rate Sort Preference Payload Values
 */
export enum ROOM_RATE_OR_PACKAGE_SORT_PREFERENCE_PAYLOAD_VALUES_ENUM {
    SORT_BY_ORDER = 'SORT_BY_ORDER',
    AVAILABLE_FIRST = 'AVAILABLE_FIRST'
}
/**
 * Constants for rate plan type
 */
export enum RATE_PLAN_TYPES_ENUM {
    REGULAR = 'regular',
    PACKAGE = 'package',
}

export enum TPA_EXTENSION_ENUM {
    LOYALTY_TIER_ID = 'LOYALTY_TIER_ID'
}
